import classNames from 'classnames'
import { upperFirst } from 'lodash'
import type { ParamValue } from 'next/dist/server/request/params'
import Image from 'next/image'
import React, { type PropsWithChildren, useState } from 'react'
import { useLocalisation } from '@/tools/i18n/client'
import {
  Coachmark,
  CrossIcon,
  IconButton,
  IconButtonSize,
  IconButtonVariants,
  PopupPlacement,
} from '@/tools/ui'
import styles from '@/tools/ui/components/header/ui/address-prompt/AddressPrompt.module.scss'
import coachmarkImage from '@/tools/ui/components/header/ui/address-prompt/assets/coachmark-image.svg'

type DecoratorOptions = {
  isBrandHeader: boolean
  city: ParamValue
  deliveryAddressText?: string
  hideArrow?: boolean
  centered?: boolean
}

type DecoratorProps = PropsWithChildren & DecoratorOptions

export const AddressPickerDecorator: React.FC<DecoratorProps> = ({
  children,
  isBrandHeader,
  deliveryAddressText,
  city,
  hideArrow,
  centered,
}) => {
  const shouldShowCoachmark = !isBrandHeader && !!city && !deliveryAddressText
  const [visible, setVisible] = useState(true)
  const handleClose = () => {
    setVisible(false)
  }
  const { t } = useLocalisation()
  const cityName = typeof city === 'string' ? upperFirst(city) : ''

  return shouldShowCoachmark ? (
    <Coachmark
      className={classNames({
        [styles.coachmarkCentered]: centered,
        [styles.hiddenArrow]: hideArrow,
      })}
      data-testid="address-coachmark"
      isOpen={visible}
      placement={PopupPlacement.bottom}
      trigger={children}
    >
      <div className={styles.coachmarkContent}>
        <Image alt="" src={coachmarkImage} />
        <div className={styles.coachmarkText}>
          <p className={'pintxo-typography-body2-emphasis'}>
            {t('address.coachmark.title', { city: upperFirst(cityName) })}
          </p>
          <p>{t('address.coachmark.description')}</p>
        </div>
        <IconButton
          aria-label={'address-close'}
          className={styles.crossIcon}
          icon={CrossIcon}
          size={IconButtonSize.small}
          variant={IconButtonVariants.transparent}
          onClick={handleClose}
        />
      </div>
    </Coachmark>
  ) : (
    children
  )
}
